import { translate } from 'vue-gettext'
import theTranslations from '@/locales/translations.json'

/**
 * At the moment, the vue-gettext plugin does not have complete support
 * for applying translations to plain JavaScript files outside the context
 * of Vue. This is a workaround that allows us to generate translations for
 * our supported languages in plain JavaScript modules.
 *
 * Note that the configuration here should be kept up to date with the
 * configuration of the vue-gettext plugin in main.js.
 */
const config = {
  language: 'en_US',
  getTextPluginSilent: false,
  getTextPluginMuteLanguages: [],
  silent: false,
}
const { gettext: $gettext } = translate
translate.initTranslations(theTranslations, config)

export { $gettext }
